import { createSelector } from 'reselect'

const getTaskGroup = (taskGroups, id) => taskGroups.find(taskGroup => taskGroup.id === id);
export const makeGetTaskGroup = () => createSelector(getTaskGroup, taskGroup => taskGroup);

const getTaskGroups = (taskGroups, ids) => taskGroups.filter(taskGroup => (ids ? ids.includes(taskGroup.id) : true)).sort((a, b) => a.order - b.order);;
export const makeGetTaskGroups = () => createSelector(getTaskGroups, taskGroup => taskGroup);

const getActiveTaskGroups = taskGroups => taskGroups
    .filter(taskGroup => !taskGroup.removed && !taskGroup.archived)
export const makeGetActiveTaskGroups = () => createSelector(getActiveTaskGroups, taskGroups => taskGroups);

const getSortedActiveTaskGroups = taskGroups => taskGroups
    .filter(taskGroup => !taskGroup.removed && !taskGroup.archived)
    .sort((a, b) => a.order - b.order);
export const makeGetSortedActiveTaskGroups = () => createSelector(getSortedActiveTaskGroups, taskGroups => taskGroups);

const getActiveProjectTaskGroups = (taskGroups, projectId) => taskGroups
    .filter(taskGroup => !taskGroup.removed && !taskGroup.archived && taskGroup.project === projectId);
export const makeGetActiveProjectTaskGroups = () => createSelector(getActiveProjectTaskGroups, taskGroups => taskGroups);

const getSortedActiveProjectTaskGroups = (taskGroups, projectId) => taskGroups
    .filter(taskGroup => !taskGroup.removed && !taskGroup.archived && taskGroup.project === projectId)
    .sort((a, b) => a.order - b.order);
export const makeGetSortedActiveProjectTaskGroups = () => createSelector(getSortedActiveProjectTaskGroups, taskGroups => taskGroups);

const getSortedActiveProjectTaskGroupsWithTasks = (taskGroups, tasks, projectId) => taskGroups
    .filter(taskGroup => !taskGroup.removed && !taskGroup.archived && taskGroup.project === projectId && tasks.some(task => task.task_group === taskGroup.id))
    .sort((a, b) => a.order - b.order);
export const makeGetSortedActiveProjectTaskGroupsWithTasks = () => createSelector(getSortedActiveProjectTaskGroupsWithTasks, taskGroups => taskGroups);
